'use strict';

const moment = require('moment-timezone');
const urlHelper = require('../utils/urlHelper');
const { CLASSES } = require('../utils/globals');

const SELECTORS = {
    body: 'body',
    datepicker: '.js-virtual-datepicker',
    timeSlotsContainer: '.js-time-slots',
    timeSlotBtn: '.js-time-slot-btn',
    timeSlotsTitle: '.js-time-slots-title',
    timeSlotConfirmBtn: '.js-time-slot-confirm-btn',
    virtualForm: '.js-virtual-form',
    virtualFormContainer: '.js-virtual-form-container',
    selectedTimeInput: '.js-selected-time',
    selectedDateInput: '.js-selected-date',
    selectedTimeSlotInput: '.js-selected-time-slot',
    selectedDateSlotInput: '.js-selected-date-slot',
    guestEmails: '.js-multiple-emails-wrapper',
    caledarContainer: '.js-caledar-container',
    booking: '.js-booking',
    bookingContainer: '.js-booking-container',
    bookingConfirmation: '.js-booking-confirmation',
    bookingTitleSection: '.js-booking-title-section',
    bookingTime: '.js-booking-time',
    bookingTimeZone: '.js-booking-time-zone',
    bookingInfoSubtitle: '.js-booking-info-subtitle',
    backButton: '.js-booking-back-btn',
    moveToNextMonthButton: '.js-move-to-next-month-button',
    noTimesText: '.js-no-times-text',
    datepickerNextButton: '.ui-datepicker-next',
    datepickerCurrentDay: '.ui-datepicker-current-day',
    timeZoneSelect: '.js-time-zone-select',
    timeZoneSelectCurrentOption: '.js-time-zone-select  option:selected',
    timeZoneInput: '.js-time-zone-input',
    appointmentCalendar: '.appointment-calendar',
    displayCalendarBtn: '.js-display-calendar',
    appointmentNextBtn: '.js-appt-member-next-btn',
    appointmentModal: '#scheduleappointment'
}

let enabledDates = null; // ['27-10-2022','31-10-2022','30-10-2022'];
let timeZone = 'US/Pacific';
let animationSpeed = 200;
let initStarted = false;

moment.tz.setDefault('US/Pacific')

function availableDays(date) {
    var sdate = $.datepicker.formatDate('dd-mm-yy', date);
    if ($.inArray(sdate, enabledDates) != -1) {
        return [true];
    }

    return [false];
}

/**
 * Format dates as needed
 * @param dates - dates from response
 * @returns {Array} formated dates
 */
function formatDates(dates) {
    let formatedDates = [];
    if (!dates || !dates.length) {
        return formatedDates;
    }

    dates.forEach(item => {
        formatedDates.push($.datepicker.formatDate('dd-mm-yy', new Date(item.AvailDate)))
    });

    return formatedDates;
}

/**
 * Ajax request to 'Events-GetAvailableDates' endpoint to get dates from Service
 * @param monthStart - monthStart
 * @param type - type of request 'dates' or 'times'
 * @returns {void}
 */
async function getWintuxData(monthStart, type, location, reason) {
    let result = null;

    let url = urlHelper.appendToUrl(Urls.getWintuxData, { type, monthStart });
    if (location && reason) {
        url = urlHelper.appendToUrl(Urls.getWintuxData, { type, monthStart, location, reason });
    }

    result = await $.ajax({
        url,
        method: 'GET',
        dataType: 'json',
    });

    return result;
}

/**
 * Init first Ajax requet to get available dates
 * @returns {void}
 */
function init() {
    $(SELECTORS.body).on('show.bs.modal', SELECTORS.appointmentModal, () => {
        if (!initStarted) {
            let selectedDate = $.datepicker.formatDate('yy-mm-dd', new Date());

            // Update Dates from the API response
            $(SELECTORS.datepicker).spinner().start();
            getWintuxData(selectedDate, 'dates').then((data) => {
                $(SELECTORS.datepicker).spinner().stop();

                if (data.results && data.results.length && data.results.length > 1) {
                    enabledDates = formatDates(data.results);
                } else if (data.results && data.results.length && data.results.length === 1 && data.results[0].Result === 'Fail' || data.error) {
                    let initialText = $(SELECTORS.noTimesText).text().trim();
                    let textToDisplay = `${initialText} ${moment(new Date()).format('MMMM')}`;

                    $(SELECTORS.noTimesText).empty().text(textToDisplay);
                    $(SELECTORS.moveToNextMonthButton).removeClass(CLASSES.hide);
                }
                initDatepicker();
                initStarted = true;
            });
        }
    });

    // Select time slot button
    $(SELECTORS.body).on('click', SELECTORS.timeSlotBtn, function (e) {
        e.preventDefault();
        const $this = $(this);
        $(SELECTORS.timeSlotBtn).removeClass(CLASSES.active);
        $(SELECTORS.timeSlotConfirmBtn).removeClass(CLASSES.active);

        $this.addClass(CLASSES.active);
        $this.next(SELECTORS.timeSlotConfirmBtn).addClass(CLASSES.active);

        $(SELECTORS.appointmentNextBtn).attr('disabled', false);
        return false;
    });

    // Confirm Time
    $(SELECTORS.body).on('click', SELECTORS.timeSlotConfirmBtn, function () {
        $(SELECTORS.virtualFormContainer).addClass(CLASSES.active);
        $(SELECTORS.caledarContainer).addClass(CLASSES.hide);
        $(SELECTORS.bookingTitleSection).addClass(CLASSES.active);
        $(SELECTORS.selectedTimeInput).val($(this).attr('data-time'));
        $(SELECTORS.selectedDateInput).val($(this).attr('data-date'));

        let selectedTimePeriod = $(this).attr('data-slot-time');
        let selectedDate = $(this).attr('data-slot-date');

        $(SELECTORS.selectedTimeSlotInput).val(selectedTimePeriod);
        $(SELECTORS.selectedDateSlotInput).val(selectedDate);
        $(SELECTORS.timeZoneInput).val($(SELECTORS.timeZoneSelectCurrentOption).data('id'))

        $(SELECTORS.bookingTime).find(SELECTORS.bookingInfoSubtitle).empty().append(`
            <span>${selectedDate}</span></br>
            <span>${selectedTimePeriod}</span>
        `);
        $(SELECTORS.bookingTime).removeClass(CLASSES.hide);
        $(SELECTORS.appointmentNextBtn).trigger('click');
    });

    // Show Next Month on btn click
    $(SELECTORS.body).on('click', SELECTORS.moveToNextMonthButton, function (e) {
        e.preventDefault();
        $(SELECTORS.datepickerNextButton).trigger('click');
        $(this).addClass(CLASSES.hide);
    });

    // Handle back button
    $(SELECTORS.backButton).on('click', function () {
        $(this).addClass(CLASSES.hide);
        $(SELECTORS.timeSlotsContainer).removeClass(CLASSES.active);
        $(SELECTORS.caledarContainer).removeClass(CLASSES.hide);

        $(SELECTORS.virtualFormContainer).removeClass(CLASSES.active);
        $(SELECTORS.bookingContainer).removeClass(CLASSES.active);
        $(SELECTORS.bookingTitleSection).removeClass(CLASSES.active);
        $(SELECTORS.bookingTime).addClass(CLASSES.hide);
    });

    // Handle Time Zone change
    $(SELECTORS.body).on('change', SELECTORS.timeZoneSelect, handTimeZoneSelect);

    $(SELECTORS.virtualForm).on('submit', handleForm);
    $(SELECTORS.body).on('click', SELECTORS.displayCalendarBtn, handleDisplayCalendarButton);
    $(SELECTORS.body).on('appointment:refreshAvailableDates', refreshAvailableDates);
}

/**
 * Refresh date picker.
 */
function refreshAvailableDates() {
    $(SELECTORS.caledarContainer).removeClass(CLASSES.hide);
    $(SELECTORS.moveToNextMonthButton).addClass(CLASSES.hide);
    let $datePicker = $(SELECTORS.datepicker);

    let year = $datePicker.datepicker('getDate').getFullYear();
    let month = $datePicker.datepicker('getDate').getMonth() + 1;

    $datePicker.spinner().start();
    let newDate = `${year}-${month}-01`;

    let locationSelected = $('.js-appointment-store-locations-select').val();
    let reasonSelected = $('.js-reason-type-select').val();

    if (!$('.party-size-section').hasClass(CLASSES.hide)) {
        reasonSelected = $('.js-event-party-select').val();
    }

    let location = locationSelected ? locationSelected : null;
    let reason = reasonSelected ? reasonSelected : null;

    // Update Dates from the API response
    getWintuxData(newDate, 'dates', location, reason).then((data) => {
        if (data.results && data.results.length && data.results.length > 1) {
            enabledDates = formatDates(data.results);
            if (enabledDates) {
                $datePicker.datepicker('refresh');
            }
            $(SELECTORS.moveToNextMonthButton).addClass(CLASSES.hide);
        } else if (data.results && data.results.length && data.results.length === 1 && data.results[0].Result === 'Fail' || data.error) {
            let initialText = $(SELECTORS.noTimesText).text().trim();
            let textToDisplay = `${initialText} ${moment(new Date()).format('MMMM')}`;

            $(SELECTORS.noTimesText).empty().text(textToDisplay);
            $(SELECTORS.moveToNextMonthButton).removeClass(CLASSES.hide);
        }

        $datePicker.spinner().stop();
    });
}

/**
 * Init first Ajax requet to get available dates
 * @returns {void}
 */
function initDatepicker() {
    $(SELECTORS.datepicker).datepicker({
            todayHighlight: true,
            dateFormat: 'yy-mm-dd',
            minDate: 0,
            multidate: true,
            startDate: new Date(),
            beforeShowDay: function (date) {
                return availableDays(date);
            },
            onChangeMonthYear: function(year, month) {
                $(SELECTORS.datepicker).spinner().start();
                let newDate = `${year}-${month}-01`;

                let locationSelected = $('.js-appointment-store-locations-select').val();
                let reasonSelected = $('.js-reason-type-select').val();

                if (!$('.party-size-section').hasClass(CLASSES.hide)) {
                    reasonSelected = $('.js-event-party-select').val();
                }

                let location = locationSelected ? locationSelected : null;
                let reason = reasonSelected ? reasonSelected : null;

                getWintuxData(newDate, 'dates', location, reason).then((data) => {
                    $(SELECTORS.datepicker).spinner().stop();
                    enabledDates = formatDates(data.results);
                    if (enabledDates) {
                        $(SELECTORS.datepicker).datepicker('refresh');
                    }
                });
            },
            onSelect: function(dateText) {
                $(SELECTORS.datepicker).spinner().start();
                let locationSelected = $('.js-appointment-store-locations-select').val();
                let reasonSelected = $('.js-reason-type-select').val();

                if (!$('.party-size-section').hasClass(CLASSES.hide)) {
                    reasonSelected = $('.js-event-party-select').val();
                }

                // handle use case where this script being consumed outside appointment modal
                let location = locationSelected ? locationSelected : null;
                let reason = reasonSelected ? reasonSelected : null;

                getWintuxData(dateText, 'times', location, reason).then((data) => {
                    $(SELECTORS.datepicker).spinner().stop();
                    renderTimeSlots(data);
                });
            }
    });
}

/**
 * Append time slots after Ajax
 * @param results - results after Ajax call
 * @returns {void}
 */
function renderTimeSlots(response) {
    var results = response.results;

    // for appointment calendar
    let isAppointment = $(SELECTORS.datepicker).parents(SELECTORS.appointmentCalendar).length > 0 ? true : false;

    $(SELECTORS.timeSlotsContainer).empty().append(`
        ${isAppointment ? `<button type="button" class="js-display-calendar f-button f-button--green d-flex mx-auto mb-3">${Resources.SELECT_DATE}</button>` : `` }
    `);

    if (!results || !results.length) {
        $('.js-error').text(response.errorMessage);
        handleDisplayCalendarButton();
        $(SELECTORS.appointmentNextBtn).attr('disabled', true);
        return;
    } else {
        $('.js-error').text('');
    }

    $(SELECTORS.timeSlotsContainer).append(`
        <h3 class="time-slots-title js-time-slots-title">
            ${moment(new Date(results[0].ApptDate)).utc().format('dddd, MMMM D, YYYY')}
        </h3>
        <div class="time-slots-list">
            ${results.map(item => {

                // if there is an error in the response, display the message
                if (item.Result === 'Fail') {
                    return `<div class="time-slots-item">
                        <span class="time-slots-item-text">${item.Message}</span>
                    </div>`;
                }

                let time = moment(item.ApptStart, 'hh:mm A').tz(timeZone).format('hh:mm A');
                let selectedTime = moment(item.ApptStart, 'hh:mm A').tz(timeZone);
                let selectedTimePeriod = `${selectedTime.format('hh:mma')} - ${selectedTime.add(1, 'hours').format('hh:mma')}`;

                return `<div class="time-slots-item">
                    <button
                        type="button"
                        class="js-time-slot-btn time-slot-btn">
                            ${time}
                    </button>
                    <button
                        type="button"
                        class="js-time-slot-confirm-btn time-slot-confirm-btn"
                        data-time="${moment(item.ApptStart, 'HHmmss A').format('HH:mm')}"
                        data-date="${moment(new Date(results[0].ApptDate)).utc().format('YYYY-MM-DD')}"
                        data-slot-time="${selectedTimePeriod}"
                        data-slot-date="${moment(new Date(results[0].ApptDate)).utc().format('dddd, MMMM D, YYYY')}"
                    >
                            ${Resources.BUTTON_CONFIRM}
                    </button>
                </div>`
            }).join('')}
        </div>
    `).addClass(CLASSES.active);

    $(SELECTORS.bookingContainer).addClass(CLASSES.active);
    $(SELECTORS.bookingTitleSection).addClass(CLASSES.active);
    $(SELECTORS.backButton).removeClass(CLASSES.hide);

    if (isAppointment) {
        $(SELECTORS.caledarContainer).hide('slide', {direction: 'left'}, animationSpeed);
        $(SELECTORS.timeSlotsContainer).show('slide', {direction: 'right'}, animationSpeed);
    }
}

/**
 * Get form values and send to Controller via Ajax
 * @returns {void}
 */
const handleForm = (e) => {
    e.preventDefault();

    const $form = $(e.target);

    $.spinner().start();
    $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: $form.serialize(),
        dataType: 'html',
        success: (html) => {
            $.spinner().stop();

            $(SELECTORS.booking).remove();
            $(SELECTORS.bookingConfirmation).html(html);
        },
        error: (error) => {
            $.spinner().stop();

            console.error('handleForm error', error); // eslint-disable-line
        }
    });
}

/**
 * Handle time zone select
 * @returns {void}
 */
const handTimeZoneSelect = (e) => {
    timeZone = e.target.value;
    $(SELECTORS.timeZoneInput).val($(SELECTORS.timeZoneSelectCurrentOption).data('id'));
    $(SELECTORS.bookingTimeZone).find(SELECTORS.bookingInfoSubtitle).empty().text($(SELECTORS.timeZoneSelectCurrentOption).data('label'));
    $(SELECTORS.datepickerCurrentDay).trigger('click');
}

/**
 * Display the calendar widget.
 */
const handleDisplayCalendarButton = () => {
    $(SELECTORS.caledarContainer).removeClass(CLASSES.hide);
    $(SELECTORS.caledarContainer).show('slide', {direction: 'left'}, animationSpeed);
    $(SELECTORS.timeSlotsContainer).hide('slide', {direction: 'right'}, animationSpeed);
    $(SELECTORS.appointmentNextBtn).attr('disabled', true);
}

module.exports = {
    init: init
};
